import { render, staticRenderFns } from "./PrintWristbandRep.vue?vue&type=template&id=1b6db445&"
import script from "./PrintWristbandRep.vue?vue&type=script&lang=js&"
export * from "./PrintWristbandRep.vue?vue&type=script&lang=js&"
import style0 from "./PrintWristbandRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports